import { ThemeCurrency, ThemeNames, ThemeType, } from '../types.js';
const name = ThemeNames.TrueNorth;
const displayName = 'True North';
const type = ThemeType.Default;
const socials = {
    facebookUrl: 'https://www.facebook.com/profile.php?id=61589608521313',
};
const siteConfig = {
    gamblingCommissionUrl: 'responsiblegambling.org/',
};
// TODO: Move to CMS
const assets = {
    logo: '/assets/images/true-north/logo.svg',
    logoLight: '/assets/images/true-north/logo-dark.svg',
    logoMobile: '/assets/images/true-north/logo-mobile.svg',
    logoCard: '/assets/images/true-north/true-north-card-logo.svg',
    banner: '/assets/images/true-north/logo.svg',
    logoBanner: '/assets/images/true-north/logo.svg',
    postalIcon: '/assets/images/true-north/postal-true-north.svg',
    loserImage: '/assets/images/loser-image.png',
    howToRedeem: [
        '/how-to-redeem/true-north/redeem-step-1.png',
        '/how-to-redeem/true-north/redeem-step-2.png',
        '/how-to-redeem/true-north/redeem-step-3.png',
        '/how-to-redeem/true-north/redeem-step-4.png',
    ],
    liveDrawWinners: '/assets/images/presenters/adam-cutout.webp',
    comingSoon: '/assets/images/true-north/coming-soon-horizontal.webp',
    comingSoonLarge: '/assets/images/true-north/coming-soon.webp',
};
const primitives = {
    theme: {
        extend: {
            colors: {
                white: '#F8FAFC',
                'pure-white': '#FFFFFF',
                primary: '#E32752',
                'primary-light': '#E5E5E5',
                'primary-lighter': '#FBDBDF',
                secondary: '#E32752',
                'secondary-dark': '#1A1A1A',
                'secondary-light': '#E32752',
                tertiary: '#B88A44',
                'tertiary-light': '#FAF398',
                'tertiary-dark': '#902237',
                black: '#1E293B',
                'black-light': '#566989',
                teal: '#000F2C',
                'pastel-blue': '#000F2C',
            },
        },
    },
};
const designTokens = {
    // General
    generalColorFocus: '#0085e5',
    // AbstractButton
    buttonBorderWidth: '1px',
    buttonBorderRadius: '1000px',
    buttonPrimaryDefaultBackground: '#b88a44',
    buttonPrimaryDefaultForeground: '#082330',
    buttonPrimaryDefaultColorBorder: '#ffffff00',
    buttonPrimaryHoverBackground: '#e6bb65',
    buttonPrimaryHoverForeground: '#082330',
    buttonPrimaryHoverColorBorder: '#ffffff00',
    buttonPrimaryPressedBackground: '#7a582d',
    buttonPrimaryPressedForeground: '#082330',
    buttonPrimaryPressedColorBorder: '#ffffff00',
    buttonSecondaryDefaultBackground: '#e32752',
    buttonSecondaryDefaultForeground: '#ffffff',
    buttonSecondaryDefaultColorBorder: '#ffffff00',
    buttonSecondaryHoverBackground: '#ff3d66',
    buttonSecondaryHoverForeground: '#ffffff',
    buttonSecondaryHoverColorBorder: '#ffffff00',
    buttonSecondaryPressedBackground: '#c21f45',
    buttonSecondaryPressedForeground: '#ffffff',
    buttonSecondaryPressedColorBorder: '#ffffff00',
    buttonTertiaryDefaultBackground: '#ffffff',
    buttonTertiaryDefaultForeground: '#082330',
    buttonTertiaryDefaultColorBorder: '#b6c6cf',
    buttonTertiaryHoverBackground: '#edf2f7',
    buttonTertiaryHoverForeground: '#082330',
    buttonTertiaryHoverColorBorder: '#b6c6cf',
    buttonTertiaryPressedBackground: '#e2eaed',
    buttonTertiaryPressedForeground: '#082330',
    buttonTertiaryPressedColorBorder: '#b6c6cf',
    // TextButton
    buttonTextFontFamily: 'Inter',
    buttonTextFontWeight: '700',
    buttonTextLineHeight: '1',
    buttonTextLgPaddingVertical: '12px',
    buttonTextLgPaddingHorizontal: '24px',
    buttonTextLgGap: '8px',
    buttonTextLgFontSize: '16px',
    buttonTextLgSizeIcon: '16px',
    buttonTextMdPaddingVertical: '8px',
    buttonTextMdPaddingHorizontal: '16px',
    buttonTextMdGap: '8px',
    buttonTextMdFontSize: '14px',
    buttonTextMdSizeIcon: '16px',
    buttonTextSmPaddingVertical: '6px',
    buttonTextSmPaddingHorizontal: '12px',
    buttonTextSmGap: '4px',
    buttonTextSmFontSize: '12px',
    buttonTextSmSizeIcon: '12px',
    // IconButton
    buttonIconXlPadding: '12px',
    buttonIconXlSizeIcon: '40px',
    buttonIconLgPadding: '8px',
    buttonIconLgSizeIcon: '24px',
    buttonIconMdPadding: '6px',
    buttonIconMdSizeIcon: '20px',
    buttonIconSmPadding: '4px',
    buttonIconSmSizeIcon: '16px',
    buttonIconTertiaryDefaultBackground: '#ffffff',
    buttonIconTertiaryDefaultForeground: '#082330',
    buttonIconTertiaryDefaultColorBorder: '#e2eaed',
    buttonIconTertiaryHoverBackground: '#edf2f7',
    buttonIconTertiaryHoverForeground: '#082330',
    buttonIconTertiaryHoverColorBorder: '#edf2f7',
    buttonIconTertiaryPressedBackground: '#e2eaed',
    buttonIconTertiaryPressedForeground: '#082330',
    buttonIconTertiaryPressedColorBorder: '#e2eaed',
    // Checkbox
    checkboxSize: '24px',
    checkboxSizeTick: '16px',
    checkboxBorderRadius: '4px',
    checkboxBorderWidth: '1px',
    checkboxColorBorder: '#e32752',
    checkboxDefaultBackground: '#ffffff',
    checkboxHoverBackground: '#edf2f7',
    checkboxPressedBackground: '#e2eaed',
    checkboxSelectedBackground: '#e32752',
    checkboxSelectedForeground: '#ffffff',
    // Switch
    switchTrackPaddingHorizontal: '4px',
    switchTrackWidth: '52px',
    switchTrackHeight: '32px',
    switchTrackBorderWidth: '1px',
    switchTrackBorderRadius: '1000px',
    switchTrackBackground: '#e2eaed',
    switchTrackSelectedBackground: '#e32752',
    switchHandleBorderRadius: '1000px',
    switchHandleSize: '24px',
    switchHandleDefaultBackground: '#082330',
    switchHandleHoverBackground: '#4c6475',
    switchHandlePressedBackground: '#01090c',
    switchHandleSelectedBackground: '#ffffff',
    switchHandleSelectedPressedBackground: '#e2eaed',
    // Tabs
    tabsItemForeground: '#082330',
    tabsItemSelector: '#e32752',
    tabsItemSizeHighlight: '4px',
    tabsItemSizeIcon: '20px',
    tabsItemPaddingTop: '8px',
    tabsItemPaddingBottom: '12px',
    tabsItemPaddingHorizontal: '8px',
    tabsItemDefaultBackground: '#ffffff00',
    tabsItemHoverBackground: '#01090c0a',
    tabsItemPressedBackground: '#01090c14',
};
export default {
    assets,
    currency: ThemeCurrency.CAD,
    displayName,
    name,
    primitives,
    socials,
    type,
    designTokens,
    siteConfig,
};
